import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import './draw-geozones.sass';
import * as L from 'leaflet';
import { getGeozoneIdFromFeature, select_geozone_layers } from '../../utils/utils';
import { deleteGeozones, editGeozones } from '../../model/actions';
import { useIsFullscreen } from 'shared/map/ui/components/control-buttons/components/fullscreen/lib';
import { getShowGeozones, getShowGeozonesRedactor } from '../../model/selectors';
import { ContextMenuForGeozone } from './context-menu';
import { FeatureGroup } from 'react-leaflet';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { useMounted } from 'shared/hooks/utils';
import { EditControl } from 'react-leaflet-draw';
import LocalizationDrawGeozones from 'entities/map.geozone/lib/localization';
import { GeoZonesContainer } from './container';
const initial_coordinates_menu = { mouseX: null, mouseY: null };
export const DrawGeozones = memo(function DrawGeozonesImpl(props) {
    const { onShowGeozoneProperties, show_geozones } = props;
    const geozones_layer = useAppSelector(select_geozone_layers);
    const show_geozones_by_user_request = useAppSelector(getShowGeozones);
    const show_geozones_redactor = useAppSelector(getShowGeozonesRedactor);
    const onDeleteGeozones = useAction(deleteGeozones);
    const onEditGeozones = useAction(editGeozones);
    const [contextmenu_coordinates, setContextmenuCoordinates] = useState(initial_coordinates_menu);
    const [geozone_id, setGeozoneId] = useState('');
    ///////////////Создаём геозону///////////////
    const onCreateGeoZone = useCallback((event) => {
        // @ts-ignore
        const { radius, ...style_without_radius } = event.layer.options;
        const new_geozone = {
            ...event.layer.toGeoJSON(),
            style: style_without_radius,
            properties: {
                ...event.layer.toGeoJSON().properties,
                radius,
            },
        };
        onShowGeozoneProperties?.(null, new_geozone);
    }, [onShowGeozoneProperties]);
    ///////////////Удаляем геозоны///////////////
    const onDeleteGeoZones = useCallback((event) => {
        //Круги нам не важны, мы их удаляем в любом случае
        const deleted_geozones = event.layers.toGeoJSON();
        // deleted_geozones будет FeatureCollection, значит все
        // удаляемые элементы будут в массиве features
        if (deleted_geozones.features.length > 0) {
            onDeleteGeozones(deleted_geozones);
        }
    }, [onDeleteGeozones]);
    ///////////////Редактируем геозоны///////////////
    const onEditGeoZones = useCallback((event) => {
        const edited_geozones = {
            type: 'FeatureCollection',
            features: [],
        };
        event.layers.eachLayer((layer) => {
            if (
            //Мы рисуем только либо круги, либо линии, либо полигоны
            layer instanceof L.Circle ||
                layer instanceof L.Polyline ||
                layer instanceof L.Polygon) {
                const edit_zone = layer.toGeoJSON();
                // @ts-ignore
                const edit_style = layer.options.original;
                //Если рисовать круг, то теряется радиус - возвращаем его обратно
                if (layer instanceof L.Circle) {
                    // @ts-ignore
                    const { radius, ...style_without_radius } = edit_style;
                    edited_geozones.features.push({
                        ...edit_zone,
                        properties: {
                            ...edit_zone.properties,
                            radius: layer.getRadius(),
                            style: style_without_radius,
                        },
                    });
                    return;
                }
                edited_geozones.features.push({
                    ...edit_zone,
                    properties: {
                        ...edit_zone.properties,
                        style: edit_style,
                    },
                });
            }
        });
        if (edited_geozones.features.length > 0) {
            onEditGeozones(edited_geozones);
        }
    }, [onEditGeozones]);
    const onOpenGeozoneProperties = useCallback(() => {
        onShowGeozoneProperties?.(geozone_id);
    }, [geozone_id, onShowGeozoneProperties]);
    const openContextMenu = useCallback((event) => {
        event.originalEvent.stopPropagation();
        event.originalEvent.preventDefault();
        setContextmenuCoordinates({
            mouseX: event.originalEvent.clientX - 2,
            mouseY: event.originalEvent.clientY - 4,
        });
        setGeozoneId(getGeozoneIdFromFeature(event.target.feature));
    }, []);
    const onCloseContextMenu = useCallback(() => {
        setContextmenuCoordinates(initial_coordinates_menu);
    }, [setContextmenuCoordinates, initial_coordinates_menu]);
    const isFullScreen = useIsFullscreen();
    const isMounted = useMounted();
    useEffect(() => {
        if (isMounted.current) {
            //Делаю локализацию геозон
            LocalizationDrawGeozones();
        }
    }, []);
    if (!show_geozones_by_user_request || !show_geozones) {
        return null;
    }
    return (_jsxs(FeatureGroup, { children: [show_geozones_redactor && !isFullScreen && (_jsx(EditControl, { position: "bottomleft", onCreated: onCreateGeoZone, onDeleted: onDeleteGeoZones, onEdited: onEditGeoZones, draw: {
                    rectangle: false,
                    marker: false,
                    circlemarker: false,
                    polyline: false,
                } })), _jsx(GeoZonesContainer, { zones: geozones_layer, onOpenContextMenu: openContextMenu, children: _jsx(ContextMenuForGeozone, { coordinates: contextmenu_coordinates, onOpenGeozoneProperties: onOpenGeozoneProperties, onClose: onCloseContextMenu }) })] }));
});
